import { render, staticRenderFns } from "./list-resources.vue?vue&type=template&id=4c55eed8&"
import script from "./list-resources.vue?vue&type=script&lang=js&"
export * from "./list-resources.vue?vue&type=script&lang=js&"
import style0 from "./list-resources.vue?vue&type=style&index=0&id=4c55eed8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports